import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=ab5394fa&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=ab5394fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab5394fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ab5394fa')) {
      api.createRecord('ab5394fa', component.options)
    } else {
      api.reload('ab5394fa', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=ab5394fa&scoped=true&", function () {
      api.rerender('ab5394fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zqB9IsqZjVVX/JS/comp/PopupBox.vue"
export default component.exports